if (!customElements.get('size-guide-component')) {
  customElements.define(
    'size-guide-component',
    class SizeGuideComponent extends HTMLElement {
      constructor() {
        super();
        this.maxWidthMm = 205;
        this.maxHeightMm = 295;
      }

      connectedCallback() {
        this.abortController = new AbortController();
        const signal = this.abortController.signal;

        this.box = this.querySelector('[data-size-guide-box]');
        this.rects = Array.from(this.querySelectorAll('[data-size-guide-rect]'));
        this.chips = Array.from(this.querySelectorAll('[data-size-guide-chip]'));

        this.chips.forEach((chip) => {
          chip.addEventListener('click', () => this.toggleChip(chip), { signal });
        });

        window.addEventListener('resize', () => this.measure(), { signal });

        const modal = this.closest('basic-modal');
        if (modal) {
          modal.addEventListener('modal:handleAfterShow', () => this.measure(), { signal });
        }

        this.measure();
      }

      disconnectedCallback() {
        this.abortController.abort();
      }

      toggleChip(chip) {
        const active = chip.getAttribute('aria-pressed') !== 'false';
        const next = !active;

        chip.setAttribute('aria-pressed', String(next));
        chip.classList.toggle('size-guide__chip--active', next);

        const rect = this.rects.find((el) => el.dataset.key === chip.dataset.key);
        if (rect) rect.hidden = !next;
      }

      measure() {
        if (!this.box) return;

        const width = this.box.clientWidth;
        if (!width) return;

        const scale = Math.min(1.55, (width - 24) / this.maxWidthMm);

        this.rects.forEach((rect) => {
          const widthMm = parseFloat(rect.dataset.wMm);
          const heightMm = parseFloat(rect.dataset.hMm);
          rect.style.width = `${widthMm * scale}px`;
          rect.style.height = `${heightMm * scale}px`;
        });

        this.box.style.height = `${Math.round(this.maxHeightMm * scale) + 34}px`;
      }
    }
  );
}
